export { a as GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE, b as GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE, G as GoogleAds } from '../../chunks/component-FHXCpNwt.js';
import 'react/jsx-runtime';
import 'next/script';
import 'react';
//# sourceMappingURL=index.js.map
